/**
 * Network Landing - tabbed layout for partner network pages.
 *
 * Tabs: Partners · People · Customers · External Roles
 * Follows the Settings page pattern (Tab + Outlet).
 */

import { AppShell } from '@/admin/components/app-shell'
import { useOrg } from '@/admin/hooks/use-org'
import { usePermissions } from '@/admin/hooks/use-permissions'
import { Tab } from '@/shared/components/ui/tab'
import { Navigate, Outlet } from 'react-router'

const BASE_TABS = [{ label: 'Partners', path: '/network/partners' }]

const TRAILING_TABS = [
  { label: 'Customers', path: '/network/customers' },
  { label: 'External Roles', path: '/network/external-roles' },
]

export function NetworkLandingPage() {
  // Partner (dealer) context has no partner book / external roles - the only
  // Network surface they get is their OWN partnership detail. Redirect the
  // list tabs straight there so the URL can't expose the upstream's network.
  const { isPartnerAccess, activePartnershipUuid, isLoading } = useOrg()
  const { can } = usePermissions()
  if (isLoading) return null
  if (isPartnerAccess && activePartnershipUuid) {
    return <Navigate to={`/network/${activePartnershipUuid}`} replace />
  }

  return (
    <AppShell>
      <main className="page-container py-10">
        <h1 className="clara-title mb-6">Network</h1>
        {/* People is tenant-admin only for now, so the tab is not offered to
            anyone who could not open it. */}
        <Tab
          tabs={[
            ...BASE_TABS,
            ...(can('users.manage')
              ? [{ label: 'People', path: '/network/people' }]
              : []),
            ...TRAILING_TABS,
          ]}
        />
        <Outlet />
      </main>
    </AppShell>
  )
}
